import { render, staticRenderFns } from "./ApexoTextarea.vue?vue&type=template&id=af59a1ac&"
import script from "./ApexoTextarea.vue?vue&type=script&lang=js&"
export * from "./ApexoTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports